/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type {
  GetGlycerinServicesCurrencyFragmentFragment,
  GetGlycerinServicesFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import {
  GetGlycerinServicesCurrencyFragmentFragmentDoc,
  GetGlycerinServicesFragmentFragmentDoc,
} from '@packages/gql/generated/shopping/graphql';
import type { getGlycerinServices } from '.';

export const getGlycerinServicesCurrencyDataMock: GetGlycerinServicesCurrencyFragmentFragment = {
  currency: 'EUR',
};

export function getGetGlycerinServicesCurrencyFragmentedData(
  data?: GetGlycerinServicesCurrencyFragmentFragment,
) {
  return makeFragmentData(
    data || getGlycerinServicesCurrencyDataMock,
    GetGlycerinServicesCurrencyFragmentFragmentDoc,
  );
}

export const getGlycerinServicesDataMock: GetGlycerinServicesFragmentFragment = {
  clusters: [
    {
      label: 'label-0',
      services: [
        { gratis: true, name: 'service-00', preselected: true, price: 13.37 },
        { gratis: true, name: 'service-01', preselected: true, price: 13.38 },
      ],
    },
    null,

    {
      label: 'label-2',
      services: [
        { gratis: true, name: 'service-20', preselected: false, price: 13.37 },
        { gratis: false, name: 'service-21', preselected: false, price: 13.38 },
      ],
    },
  ],
};

export const getGlycerinServicesReturnMock: ReturnType<typeof getGlycerinServices> = {
  services: [
    {
      currency: getGlycerinServicesCurrencyDataMock.currency,
      displayedPrice: 0,
      serviceType: getGlycerinServicesDataMock.clusters[0]!.label,
      name: getGlycerinServicesDataMock.clusters[0]!.services[0].name!,
      quantity: 1,
    },
    {
      currency: getGlycerinServicesCurrencyDataMock.currency,
      displayedPrice: 0,
      serviceType: getGlycerinServicesDataMock.clusters[0]!.label,
      name: getGlycerinServicesDataMock.clusters[0]!.services[1].name!,
      quantity: 1,
    },
    {
      currency: getGlycerinServicesCurrencyDataMock.currency,
      displayedPrice: 0,
      serviceType: getGlycerinServicesDataMock.clusters[2]!.label,
      name: getGlycerinServicesDataMock.clusters[2]!.services[0].name!,
      quantity: 0,
    },
    {
      currency: getGlycerinServicesCurrencyDataMock.currency,
      displayedPrice: getGlycerinServicesDataMock.clusters[2]!.services[1]!.price! * 100,
      serviceType: getGlycerinServicesDataMock.clusters[2]!.label,
      name: getGlycerinServicesDataMock.clusters[2]!.services[1].name!,
      quantity: 0,
    },
  ],
};

export function getGetGlycerinServicesFragmentedData(data?: GetGlycerinServicesFragmentFragment) {
  return makeFragmentData(
    data || getGlycerinServicesDataMock,
    GetGlycerinServicesFragmentFragmentDoc,
  );
}
